import {
  Box,
  Flex,
  Text,
  TonicProps,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import React from 'react';
import TextEllipsis from '@Components/Common/Tooltip/TextEllipsis';
import { Info } from '@Components/Common/Info';

export default function DashboardCard(
  props: {
    title?: string;
    row?: number;
    column?: number;
    height?: TonicProps['height'];
    titleBar?: React.ReactNode;
    iconContent?: string;
    children: React.ReactNode;
  } & Omit<TonicProps, 'height'>
) {
  const {
    title,
    row,
    column,
    height,
    titleBar,
    children,
    iconContent = null,
    ...rest
  } = props;
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });

  const header = (
    <Flex height="48px" width="100%" pb="12px">
      {title && (
        <Flex
          height="24px"
          fontSize="18px"
          fontWeight="600"
          maxWidth="70%"
          color={colorStyle.color.primary}
          align="center"
          gap="10px"
        >
          <TextEllipsis>{title}</TextEllipsis>
          {iconContent && (
            <Info
              content={iconContent}
              contentStyle={{
                width: '326px',
                fontWeight: 400,
                fontSize: '14px',
              }}
            />
          )}
        </Flex>
      )}
      <Flex flex="1" align="center" justify="flex-end">
        {titleBar ?? null}
      </Flex>
    </Flex>
  );

  return (
    <Box
      gridRow={`auto/span ${row || 1}`}
      gridColumn={`auto/span ${column || 1}`}
      height={height || '288px'}
      {...rest}
    >
      <Box
        height="100%"
        padding="12px 16px 14px 24px"
        backgroundColor={
          colorMode === 'dark'
            ? colorStyle.background.tertiary
            : colorStyle.background.primary
        }
        border={colorMode === 'dark' ? '' : '1px solid'}
        borderColor={colorMode === 'dark' ? '' : colorStyle.background.tertiary}
      >
        {(titleBar || title) && header}
        <Box height="calc(100% - 48px)">{children}</Box>
      </Box>
    </Box>
  );
}

export function DashboardCardDescription(props: { children: React.ReactNode }) {
  const { children } = props;
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });

  return (
    <Box mb="8x">
      <Text
        color={
          colorMode === 'dark'
            ? colorStyle.color.secondary
            : colorStyle.color.emphasis
        }
        maxWidth="1400px"
      >
        {children}
      </Text>
    </Box>
  );
}
